<mat-form-field class="dict-ofwcas-partners">
  <mat-select [formControl]="control" [required]="required" (selectionChange)="onSelectionChange($event)" [multiple]="multiple" [placeholder]="label">
    <mat-option>
      <ngx-mat-select-search [formControl]="ofwcasPartnerFilterCtrl" placeholderLabel="Wyszukaj..."
                             noEntriesFoundLabel="Nie znaleziono działu">
      </ngx-mat-select-search>
    </mat-option>
    <mat-option *ngFor="let option of items" [value]="[option.uuid, !!option.nip, !option.nip]">
      {{option.nip?  option.shortName + ' NIP:  ' + option.nip + ' (Partner)':  option.fullName + ' Pesel: ' + option?.pesel + ' (OFWCA)' }}
    </mat-option>
    <mat-option *ngIf="items.length > 0" [value]="[dict?.id, false, false]">
     {{dict?.name}}
    </mat-option>
  </mat-select>
  <button *ngIf="((control.value !== null
    && multiple && control.value.hasOwnProperty('length')
    && control.value.length > 0) || (!multiple && control.value))
    && !required"
          matSuffix
          mat-icon-button
          type="button"
          aria-label="Clear"
          (click)="clearValue(); $event.stopPropagation()">
    <mat-icon>close</mat-icon>
  </button>
  <mat-error *ngIf="control.hasError('required')">To pole jest wymagane</mat-error>
</mat-form-field>

